export const AVAILABILITY_TYPES = {
  SINGLE_EVENT: 'SINGLE_EVENT',
  RECURRING: 'RECURRING',
  FULL_DAYS: 'FULL_DAYS',
  RECURRING_FULL_DAYS: 'RECURRING_FULL_DAYS',
};

export const AVAILABILITY_LABELS = {
  SINGLE_EVENT: 'event',
  RECURRING: 'recurring event',
  FULL_DAYS: 'fullday event',
  RECURRING_FULL_DAYS: 'recurring fullday',
};

export const AVAILABILITY_STATUS = {
  PENDING: 'pending',
  DELETED: 'deleted',
};
